import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=c77e810c&scoped=true&"
import script from "./CommonForm.vue?vue&type=script&lang=js&"
export * from "./CommonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77e810c",
  null
  
)

export default component.exports